import { combineReducers } from 'redux'
import fuse from './fuse'
import place from './place.reducer'
import setupSteps from './setupSteps.reducer'
import topicReducer from '../../main/topics/store/reducers/topic-reducer'
import loadSpinner from './loadSpinner.reducer'
import auth from 'app/auth/store/reducers'
import quickPanel from 'app/fuse-layouts/shared-components/quickPanel/store/reducers'
import conversation from './conversation.reducer'
import appSettings from './appSettings.reducer'
import maintenanceConfig from './maintenance.reducer'
import countries from './countries.reducer'
import nationalities from './nationalities.reducer'
import statePhysical from './statePhysical.reducer'
import stateMailing from './stateMailing.reducer'
import importCSV from '../importCSV'
import importExternalSource from '../importExternalSource'
import groups from '../groups'
import warningDialog from './warningDialog.reducer'
import categories from '../categories'

const createReducer = (asyncReducers) =>
  combineReducers({
    auth,
    fuse,
    quickPanel,
    place,
    setupSteps,
    loadSpinner,
    appSettings,
    conversation,
    maintenanceConfig,
    countries,
    nationalities,
    topicReducer,
    statePhysical,
    stateMailing,
    importCSV,
    importExternalSource,
    groups,
    warningDialog,
    categories,
    ...asyncReducers,
  })

export default createReducer
